/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { ControlTable } from '../../../components/Table';
import { isEmpty } from 'lodash';
import useForm from '../../../hooks/useForm';
import { dateToFormat, getDay } from '../../../utils/date';
import { getParams } from '../../../utils/params';
import Filters from '../../Filters';
import { ADMINISTRATIVE_CERTIFICATE_TYPES } from '../../../constants/TaxPortal/ADMINISTRATIVE_CERTIFICATE';
import AdministrativeCertificateIssuePopup from './AdministrativeCertificateIssuePopup';
import { getAdministrativeCertificates } from '../../../apis/tax-portal/administrativeCertificate';
import Button from '../../Button';
import ToolTip from '../../ToolTip/ToolTip';
import ManagerCounseling from '../../Counseling/ManagerCounseling';
// ADMINISTRATIVE_CERTIFICATE
const AdministrativeCertificateList = (props) => {
  const {
    taxContactType,
    company,
    companies,
    user,
  } = useSelector(
    (store) => ({
      user: store.Profile.user,
      taxContactType: store.TaxPortal.taxContactType,
      company: store.Profile.company,
      companies: store.Data.companies,
    }),
    shallowEqual
  );

  const [toggle, setToggle] = useState(false);
  const [myCompany, setMyCompany] = useState({});
  const [timerValue, setTimerValue] = useState(0);
  const timerId = useRef(null);
  const [filters] = useState([{
    title: "요청일",
    key: 'range.createdTime',
    type: "customdatepicker",
  },
  {
    title: "상호명",
    type: "input",
    key: "bizNm",
  },
  {
    title: "민원증명종류",
    type: "select",
    key: "svcCd",
    options: {
      list: ADMINISTRATIVE_CERTIFICATE_TYPES.map(({ label, id }) => { return { label, value: id }; }),
    },
  },]);

  const [counselingData, setCounselingData] = useState(null);
  const [open, setOpen] = useState(false);

  const [fields] = useState([
    {
      title: "요청일",
      key: "createdTime",
      onValue: (data) => {
        return dateToFormat(data, 'YYYY-MM-DD');
      }
    },
    {
      title: "상호명",
      key: "bizNm",
      onValue: (v, _f, d) => !isEmpty(v) ? v : d?.taxpayer?.ceoName
    },
    {
      title: "증명서",
      key: "svcCd",
      onValue: (d) => {
        const target = ADMINISTRATIVE_CERTIFICATE_TYPES.find(i => i.id === d);
        return target.label;
      }
    },
    {
      title: "처리상태",
      key: "state",
      width: '80px',
      onValue: (d) => {
        let state = "대기중";
        if (d === 1)
          state = "발급완료";
        if (d === 2)
          state = "발급실패";
        return state;
      }
    },
    {
      title: "발급번호",
      key: "cerCvaIsnNo"
    },
    {
      title: "다운로드",
      key: "response",
      onValue: (data, field, datas) => {
        if (datas.state !== 1) return '-';
        return <a
          onClick={() => administrativeCertificateDownload(data, datas)}
          style={{ fontSize: "20px" }}
        >
          <i className="bx bx-download"></i>
        </a>;
      }
    },
    {
      title: "전송",
      key: "state",
      onValue: (value, _field, data) => {
        return !isEmpty(data?.taxpayer?.companyToTaxpayer?.company) ?
          value === 1 ? (
            <Button
              size="x-sm"
              color="gray-line"
              onClick={() => {
                convertCounselingData(data);
                setOpen(true);
              }}

            >
              전송하기
            </Button>
          ) : <>-</>
          : <>사용불가<ToolTip tooltiptext="수임처관리에서 wecake Biz와 연동하신 뒤에 이용하실 수 있습니다." />
          </>;
      }
    },
  ]);

  const administrativeCertificateDownload = (data, datas) => {
    const { fileName, linkSource } = administrativeCertificateFileData(data, datas);
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };


  const administrativeCertificateFileData = (data, datas) => {
    const item = JSON.parse(data);
    const base64String = Buffer.from(item.pdfHex, 'hex').toString('base64');
    const documentName = ADMINISTRATIVE_CERTIFICATE_TYPES.find(i => i.id === datas.svcCd);
    const linkSource = `data:application/pdf;base64,${base64String}`;
    const fileName = `${datas.bizNm}_${documentName.label}_${dateToFormat(datas.createdTime)}.pdf`;

    return {
      fileName, linkSource
    };
  };



  useEffect(() => {
    if (!isEmpty(company)) {
      const managerCompany = companies.find((com) => com.companyIdx === user.managerCompanyIdx);
      setMyCompany(managerCompany);
    }
  }, [company]);



  const submit = async (form) => {
    getAdministrativeCertificates({ ...getParams(form), taxSearchType: taxContactType })
      .then((res) => {
        const { rows = [], total = 0 } = res.data;
        setList(rows);
        setTotal(total);
      })
      .catch((err) => {
        console.error(err.response);
      }).finally(() => setIsLoading(false));
  };

  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit,
  } = useForm({
    offset: 0,
    limit: 10,
    range: {
      createdTime: [getDay(7), getDay()]
    }
  });

  useEffect(() => {
    if (!isEmpty(taxContactType) && !isEmpty(myCompany)) {
      setSubmit(submit);
      submit({ ...form });
    }
  }, [taxContactType, myCompany]);


  useEffect(() => {
    timerId.current = setInterval(() => {
      setTimerValue(1);
    }, 1000 * 5);
    return () => clearInterval(timerId.current);
  }, []);

  useEffect(() => {
    if (timerValue === 1) {
      setTimerValue(0);
      reSubmit();
    }
  }, [timerValue]);

  const tableButtons = [
    {
      label: "민원증명 발급신청",
      action: () => {
        setToggle(true);
      }
    }
  ];


  const convertCounselingData = (data) => {
    const { fileName, linkSource } = administrativeCertificateFileData(data.response, data);
    const counseling = {
      category: 7,
      fileIdxes: [],
      title: `${data.bizNm} ${ADMINISTRATIVE_CERTIFICATE_TYPES.find(i => i.id === data.svcCd)?.label}`,
      content: `<p><a download="${fileName}" href="${linkSource}">${fileName.split('.pdf')[0]
        } 다운로드</a></p>`,
      companyIdx: data.taxpayer.companyToTaxpayer?.companyIdx,
      careCompany: { ...data.taxpayer.companyToTaxpayer?.company },
    };

    setCounselingData(counseling);
  };

  return (
    <div className="tax-portal-schedule">

      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        buttons={tableButtons}
        className='overflow-visible'
      />
      <AdministrativeCertificateIssuePopup
        close={() => {
          setToggle(false);
          reSubmit();
        }}
        isOpen={!!toggle}
      />

      <ManagerCounseling
        counselingType={"tax"}
        counseling={counselingData}
        setCounseling={setCounselingData}
        open={open}
        setOpen={setOpen}
        submit={() => { setCounselingData(null); }}
        orgMode={"create"}
      />
    </div>
  );
};

export default AdministrativeCertificateList;